var React = require('react');

function IconYoutubeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icon--youtube","fillRule":"evenodd","clipRule":"evenodd","d":"M12.986 7.6412L7.55133 11.0467C6.98067 11.4058 6.66667 11.1146 6.66667 10.4034V3.6008C6.666 2.8882 6.97 2.597 7.542 2.9519L12.9833 6.3434C13.5553 6.6983 13.3313 7.3605 12.986 7.6412ZM16.6667 0H3.33333C1.49267 0 0 1.5673 0 3.5V10.5C0 12.4334 1.49267 14 3.33333 14H16.6667C18.508 14 20 12.4334 20 10.5V3.5C20 1.5673 18.508 0 16.6667 0Z","fill":"#A5A5A5"}));
}

IconYoutubeInline.defaultProps = {"width":"20","height":"14","viewBox":"0 0 20 14","fill":"none"};

module.exports = IconYoutubeInline;

IconYoutubeInline.default = IconYoutubeInline;
